module.exports = {"TXTCLI_LoadingXX":{"id":"TXTCLI_LoadingXX","defaultMessage":"読み込み中…","flags":["TRACK"],"track":"Loading..."}}